import TabPage from "./tab-page";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/filtering";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./bao-dialog";
import BaseAuditDialog from "./base-audit-dialog";
/**
 * Shows Audit Dialog For given ConfigurationItemId
 */
class ConfigurationItemAuditDialog extends BaseAuditDialog {
    constructor(id: string, objectName: string, tabPage: TabPage, collectionUrl?: string, overview?: boolean) {
        if (collectionUrl == null) {
            collectionUrl = "ConfigurationItemHistory/GetAuditCollection";
        }
        super(id, objectName, tabPage, collectionUrl, overview);
    }
}
export default ConfigurationItemAuditDialog;